import { render, staticRenderFns } from "./demo-fee-list.vue?vue&type=template&id=ffe88b08&scoped=true"
import script from "./demo-fee-list.vue?vue&type=script&lang=js"
export * from "./demo-fee-list.vue?vue&type=script&lang=js"
import style0 from "./demo-fee-list.vue?vue&type=style&index=0&id=ffe88b08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe88b08",
  null
  
)

export default component.exports